import { render, staticRenderFns } from "./SaveReportSettingsCard.vue?vue&type=template&id=6defdefd"
import script from "./SaveReportSettingsCard.vue?vue&type=script&lang=ts"
export * from "./SaveReportSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6defdefd')) {
      api.createRecord('6defdefd', component.options)
    } else {
      api.reload('6defdefd', component.options)
    }
    module.hot.accept("./SaveReportSettingsCard.vue?vue&type=template&id=6defdefd", function () {
      api.rerender('6defdefd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reportengine/SaveReportSettingsCard.vue"
export default component.exports